import {Component, Watch} from 'vue-property-decorator'
import {Vue} from 'vue-property-decorator'

const Store = Component
const VueStore = Vue

export {Store, Watch, VueStore}
